/**
 * Created by christiancueni on 06/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */


import { Label } from './labels.models';
import { LabelActionTypes } from './labels.actions';
import { CustomAction } from '../../actions/CustomAction';

export interface LabelsState {
    labels: Label[];
}

const initialLabelsState: LabelsState = {
    labels: []
};

export function reducer(state = initialLabelsState, action: CustomAction): LabelsState {
    switch (action.type) {
        case LabelActionTypes.LABELS_GET_LABELS_SUCCESS:
        case LabelActionTypes.LABELS_UPDATE_LABELS_SUCCESS:
            return {
                labels: action.payload
            };

        case LabelActionTypes.LABELS_RESET:
            return Object.assign({}, initialLabelsState);

        default: {
            return state;
        }
    }
}

// getters for state members

export function getLabels(state: LabelsState) {
    return state.labels;
}

